import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useWorkspaceFilePickerStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },

  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: designTokens.spacing[8],
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    maxHeight: "260px",
    overflowY: "auto",
    overflowX: "hidden",
    padding: 0,
    margin: 0,
    listStyle: "none",
  },

  item: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: projectIqTokens.card,
    cursor: "pointer",
    width: "100%",
    boxSizing: "border-box",
    minWidth: 0,
    transition: `background-color ${designTokens.transition.fast}, border ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: projectIqTokens.tealSoft,
      border: `1px solid ${projectIqTokens.tealLine}`,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },

  itemSelected: {
    backgroundColor: projectIqTokens.tealSoft,
    border: `1px solid ${projectIqTokens.teal}`,
    ":hover": {
      backgroundColor: projectIqTokens.tealSoft,
    },
  },

  radioDot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "18px",
    height: "18px",
    minWidth: "18px",
    borderRadius: designTokens.borderRadius.full,
    border: `2px solid ${projectIqTokens.faint}`,
    backgroundColor: projectIqTokens.card,
    flexShrink: 0,
  },

  radioDotSelected: {
    border: `2px solid ${projectIqTokens.teal}`,
  },

  radioDotInner: {
    width: "10px",
    height: "10px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: projectIqTokens.teal,
  },

  fileIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    borderRadius: designTokens.borderRadius.md,
    flexShrink: 0,
  },

  fileIconPdf: {
    backgroundColor: "rgba(194,85,63,0.12)",
    color: projectIqTokens.rust,
  },

  fileIconXls: {
    backgroundColor: "rgba(47,158,110,0.12)",
    color: projectIqTokens.green,
  },

  fileIconPpt: {
    backgroundColor: "rgba(217,138,43,0.12)",
    color: projectIqTokens.amber,
  },

  fileIconDefault: {
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.ink3,
  },

  fileInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },

  fileName: {
    fontSize: "13.5px",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    margin: 0,
  },

  fileMeta: {
    fontSize: designTokens.fontSize.xxs,
    color: projectIqTokens.faint,
    margin: 0,
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[8]} ${designTokens.spacing[4]}`,
    textAlign: "center",
    color: projectIqTokens.muted,
    fontSize: designTokens.fontSize.sm,
    border: `1px dashed ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
  },
});
